import { Box, Card, TextField, Button, Typography } from "@mui/material"
import GoogleIcon from '@mui/icons-material/Google';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types'
import { useForm } from "react-hook-form";


const LoginCard = ({ onEmailSignIn, onGoogleSignIn }) => {

    const handleGoogleSignIn = () => onGoogleSignIn()

    const { register, handleSubmit } = useForm()

    return (
        <Card raised sx={{ display: 'flex', flexDirection: 'column', p: 2, gap: 1 }}>
            <form onSubmit={handleSubmit(onEmailSignIn)}>
                <Box display='flex' flexDirection='column' gap={1}>
                    <TextField label='Email Address' variant='filled' size='small' {...register('email')} />
                    <TextField label='Password' variant='filled' size='small' type='password' {...register('password')} />
                    <Button variant='contained' type='submit'>Login</Button>
                </Box>
            </form>

            <Button variant='outlined' startIcon={<GoogleIcon />} onClick={handleGoogleSignIn}>Login with Google</Button>
            <Typography variant='caption'>
                <Link to="/reset">Forgot Password</Link>
            </Typography>
            <Typography variant='caption'>
                Are you a filthy casual and don't have an account? <Link to="/register">Register</Link> here.
            </Typography>
        </Card>
    )
}

LoginCard.propTypes = {
    onEmailSignIn: PropTypes.func,
    onGoogleSignIn: PropTypes.func
}

export default LoginCard